import {INSTALLER_MENU, PATHS} from '../utils/constants';
import {getLicenseInfo, updateLicense} from '../services/account';
import {Modal} from 'antd';

export default {
  namespace: 'license',
  state: {
    data: ''
  },
  reducers: {
    update(state, {payload}) {
      return {...state, ...payload};
    }
  },
  effects: {
    *loadLicenseInfo(_, {put, call, select}) {
      const {locale} = yield select(state => state.i18n);
      const {status, msg, data} = yield call(getLicenseInfo, {locale});
      if (status === 0) {
        yield put({type: 'update', payload: {data}});
      } else {
        Modal.error({content: msg});
      }
    },
    *updateLicenseInfo({value,resolve,reject}, {put, call, select}) {
      const {locale} = yield select(state => state.i18n);
      const {status, msg} = yield call(updateLicense, {locale,value});
      if (status === 0) {
        yield put({type: 'update', payload: {value}});
        resolve && resolve();
      } else {
        reject && reject(msg);
      }
    }
  },
  subscriptions: {
    set({dispatch, history}) {
      return history.listen(({pathname}) => {
        if (pathname === PATHS.license) {
          const token = sessionStorage.getItem('token');
          const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
          if (token && userInfo && userInfo.roleId === 0) {
            dispatch({type: 'loadLicenseInfo'});
            dispatch({
              type: 'menu/setMenus',
              menus: {data: INSTALLER_MENU, status: 0}
            });
          } else {
            dispatch({type: 'top/logOff'});
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/license.js